import DOMPurify from "dompurify";

/**
 * Defense-in-depth for every admin-authored HTML field rendered on the public site (blog
 * posts, site content blocks) -- the real trust boundary is Firestore's own `isAdmin()` write
 * rule (only Devina's account can write these fields at all), but sanitizing at render time too
 * means a compromised admin account can't turn a blog post into stored XSS against every
 * visitor. Client-only (DOMPurify needs a DOM), which matches every place this is called --
 * all admin-content rendering in this app already happens in "use client" components.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html);
}
